/**
 * Auto selects text on input focus.
 *
 * @unstable
 */

import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[autoSelect]',
  standalone: false,
})
export class AutoSelect {
  readonly elRef = inject(ElementRef);

  public activeElement: any = null;

  @HostListener('focus') onFocus(): void {
    if (this.activeElement !== this.elRef.nativeElement) {
      this.elRef.nativeElement.select();

      this.activeElement = document.activeElement;
    }
  }

  @HostListener('mousedown') onMouseDown(): void {
    this.activeElement = document.activeElement;
  }
}
